import { enIN } from "../../../../date-fns/locale/en-IN.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    enIN
  }
};